<template>
  <base-keyboard-component
    @addToInput="addToInputHandler"
    @removeLastChar="removeLastCharHander"
    :keyLayout="keyboardLayout"
    keyboardClass="small-keyboard"
  ></base-keyboard-component>
</template>

<script>
import { mapGetters } from "vuex";
import BaseKeyboardComponent from "./BaseKeyboardComponent.vue";

export default {
  components: { BaseKeyboardComponent },
  name: "SmallKeyboardComponent",
  data() {
    return {
      layout: "letters",
    };
  },
  mounted() {
    if (this.keyboard.value === this.$i18n.t("id_check.not_found")) {
      this.$store.commit("SET_KEYBOARD_VALUE", "");
    }
  },
  computed: {
    ...mapGetters(["keyboard"]),
    keyboardLayout() {
      if (
        this.keyboard.inputKey === "zip_code"
      ) {
        return this.numberLayout;
      } else {
        return this.lettersLayout;
      }
    },
    lettersLayout() {
      return {
        letters: [
          [
            { label: "^" },
            { label: "1" },
            { label: "2" },
            { label: "3" },
            { label: "4" },
            { label: "5" },
            { label: "6" },
            { label: "7" },
            { label: "8" },
            { label: "9" },
            { label: "0" },
            { label: "backspace", action: "remove", classes: "four-col" },
          ],
          [
            { label: "tab", action: "tab", classes: "double-col"},
            { label: "Q" },
            { label: "W" },
            { label: "E" },
            { label: "R" },
            { label: "T" },
            { label: "Z" },
            { label: "U" },
            { label: "I" },
            { label: "O" },
            { label: "P" },
            { label: "Ü" },
          ],
          [
            { label: "caps", classes: "double-col", action: 'caps' },
            { label: "A" },
            { label: "S" },
            { label: "D" },
            { label: "F" },
            { label: "G" },
            { label: "H" },
            { label: "J" },
            { label: "K" },
            { label: "L" },
            { label: "Ö" },
            { label: "Ä" },
          ],
          [
            { label: "shift", action: "shift", classes: "four-col" },
            { label: "Y" },
            { label: "X" },
            { label: "C" },
            { label: "V" },
            { label: "B" },
            { label: "N" },
            { label: "M" },
            { label: "@" },
            { label: "." },
            { label: "123", action: "toggle"  },
          ],
        ],
        symbols: [
          [
            { label: "°" },
            { label: "!" },
            { label: '"' },
            { label: "§" },
            { label: "$" },
            { label: "%" },
            { label: "&" },
            { label: "/" },
            { label: "(" },
            { label: ")" },
            { label: "=" },
            { label: "backspace", action: "remove", classes: "four-col" },
          ],
          [
            { label: "@" },
            { label: "€" },
            { label: "+" },
            { label: "~" },
            { label: "*" },
            { label: "#" },
            { label: "'" },
            { label: "<" },
            { label: ">" },
            { label: "|" },
            { label: "µ" },
            { label: "ABC", action: "toggle" },
          ],
          [
            { label: ";" },
            { label: ":" },
            { label: "_" },
            { label: "-" },
          ],
        ],
      };
    },
    numberLayout() {
      return {
        letters: [
          [{ label: "1" }, { label: "2" }, { label: "3" }],
          [{ label: "4" }, { label: "5" }, { label: "6" }],
          [{ label: "7" }, { label: "8" }, { label: "9" }],
          [{ label: "0" }, { label: "<", action: "remove", classes: "four-col" }],
        ],
      };
    },
  },
  methods: {
    toggleLayout() {
      this.layout = this.layout === "letters" ? "symbols" : "letters";
    },
    addToInputHandler(char) {
      let initialValue = this.keyboard.value || "";

      initialValue += char;

      this.$store.commit("SET_KEYBOARD_VALUE", initialValue);
    },
    removeLastCharHander() {
      let initialValue = this.keyboard.value || "";

      initialValue = initialValue.slice(0, -1);

      this.$store.commit("SET_KEYBOARD_VALUE", initialValue);
    },
  },
};
</script>

<style scoped></style>
